var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerschiedeneRalFarben = function SvgVerschiedeneRalFarben(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "verschiedene_RAL-Farben_svg__Ebene_2",
    viewBox: "0 0 109.68 94.98"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verschiedene_RAL-Farben_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.14 93.73 1.44 47.49l26.7-46.24h53.4l26.7 46.24-26.7 46.24z",
    className: "verschiedene_RAL-Farben_svg__cls-2"
  })), /*#__PURE__*/React.createElement("style", null, ".verschiedene_RAL-Farben_svg__cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.5px}.verschiedene_RAL-Farben_svg__cls-3{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "verschiedene_RAL-Farben_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#verschiedene_RAL-Farben_svg__clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.87 4.13 25.03 43.36-25.03 43.36H29.81L4.77 47.49 29.81 4.13h50.07m1.66-2.88h-53.4L1.44 47.49l26.7 46.24h53.4l26.7-46.24z",
    style: {
      fill: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.14 93.73 1.44 47.49l26.7-46.24h53.4l26.7 46.24-26.7 46.24z",
    className: "verschiedene_RAL-Farben_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.85 59.54-6.22-9.7h-4.87v9.7h-3.04V35.12h9.81c4.47 0 7.65 2.86 7.65 7.36s-3 6.81-6.33 7.1l6.59 9.96zm-4.68-21.71h-6.41v9.33h6.41c2.89 0 4.87-1.94 4.87-4.69s-1.98-4.65-4.87-4.65ZM65.51 59.54l-2.16-5.42H50.98l-2.16 5.42h-3.37l9.81-24.42h3.77l9.85 24.42zm-8.34-21.71-5.31 13.58h10.58zM72.07 59.54V35.12h3.04v21.71h11.35v2.71z",
    className: "verschiedene_RAL-Farben_svg__cls-3"
  }))));
};
export default SvgVerschiedeneRalFarben;